$( document ).ready(function() {
      
   $( ".gem-diagram" ).click(function() {
    $( ".gem-image" ).slideToggle('fast');
  });        
  
  $('.beauty').each(function() {
    var $this = $(this),
        html = $this.html(),
        blackDiamond = '\u25C6';

    html = html.replace(/\*/g, blackDiamond);
    $this.html(html);

	});
  
    
  $('.template-page .user-content').each(function() {
    var $this = $(this),
        html = $this.html(),
        blackDiamond = '\u25C6',
        whiteDiamond = '\u25C7';

    html = html.replace(/\*/g, blackDiamond);
    $this.html(html);

    html = html.replace(/\+/g, whiteDiamond);
    $this.html(html);

	});
});